import { Stack } from '@mui/material';
import { TimelineNode } from './interfaces';
import { getTimelineNodeKey } from './utils.timeline';
import { AgentProgressTimelineBlock } from './TimelineBlock';

export function AgentProgressTimeline({ className, nodes }: { className?: string; nodes: TimelineNode[] }) {
  if (nodes.length === 0) {
    return null;
  }

  return (
    <Stack spacing={1.5} className={className}>
      {nodes.map((node) => (
        <AgentProgressTimelineBlock key={getTimelineNodeKey(node)} node={node} />
      ))}
    </Stack>
  );
}
